// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"12\" height=\"12\" viewBox=\"0 0 24 24\"><path fill=\"%23333333\" d=\"M7 10l5 5 5-5z\"/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.add-reseller-container {
  font-family: Arial, sans-serif;
  font-size: clamp(10px, 2.5vw, 12px);
  padding: 0;
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
}

.loading-overlay {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.spinner {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.nav-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 1rem;
  width: 100%;
  border-radius: 5px;
  border-bottom: none;
}

.nav-tab {
  flex: 1 1;
  min-width: 100px;
  max-width: 100%;
  padding: 0.4rem;
  font-size: clamp(0.65rem, 2vw, 0.8rem);
  font-weight: bold;
  text-align: center;
  border-radius: 5px;
  border: none;
  cursor: pointer;
  transition: transform 0.2s ease, opacity 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  text-decoration: none;
}

.nav-tab i {
  font-size: clamp(0.8rem, 2.5vw, 1rem);
}

.breadcrumb {
  margin-bottom: 1rem;
  font-size: clamp(0.65rem, 2vw, 0.8rem);
  width: 100%;
  max-width: 100%;
}

.breadcrumb-divider {
  margin: 0 0.5rem;
}

.page-title {
  font-size: clamp(12px, 3vw, 14px);
  font-weight: bold;
  margin-bottom: 1rem;
}

.tab-controls {
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
  flex-wrap: wrap;
  width: 100%;
  max-width: 100%;
}

.tab-link {
  display: flex;
  align-items: center;
  text-decoration: none;
  font-weight: bold;
  font-size: clamp(0.65rem, 2vw, 0.8rem);
  transition: color 0.3s ease;
}

.tab-indicator {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: clamp(16px, 3vw, 20px);
  height: clamp(16px, 3vw, 20px);
  border-radius: 50%;
  margin-right: 0.5rem;
  font-size: clamp(0.6rem, 1.8vw, 0.7rem);
  transition: all 0.3s ease;
}

.tab-label {
  border-bottom: none; /* Removed gray underline */
  transition: none; /* Removed transition to avoid any visual artifacts */
}

.tab-content {
  width: 100%;
  max-width: 100%;
  padding: 0; /* let card-container handle spacing */
  margin-top: 1rem;
  box-sizing: border-box;
}

.card-container {
  border-radius: 12px;
  padding: 1.5rem;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

/* Optional helper if you want a slightly elevated look */
.theme-panel {
  transition: background-color 0.3s ease, border 0.3s ease;
}


.section-title {
  font-size: clamp(0.7rem, 2.2vw, 0.9rem);
  font-weight: bold;
  margin-bottom: 1.5rem;
}

.section-title--spaced {
  margin-top: 1.5rem;
}

.section-subtitle {
  font-size: clamp(0.65rem, 2vw, 0.8rem);
  font-weight: normal;
  margin-bottom: 0.5rem;
}

.form-group {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 1rem;
  justify-content: flex-start;
  align-items: flex-start;
}

.form-group--spaced {
  margin-bottom: 1rem;
}

.input-container {
  flex: 0 0 15%;
  width: 15%;
  min-width: clamp(100px, 15%, 150px);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.input-container.full-width {
  flex: 0 0 100%;
  width: 100%;
  min-width: 100%;
}

.input-label {
  display: block;
  margin-bottom: 0.5rem;
}

.input-field,
.select-field,
.textarea-field,
.date-input-container,
.country-selector,
.file-input-container {
  width: 100%;
  padding: 0.4rem;
  font-size: clamp(0.65rem, 2vw, 0.8rem);
  border-radius: 4px;
  outline: none;
  box-shadow: none;
  box-sizing: border-box;
  height: 2rem;
}

.date-input-container input,
.file-input-container {
  width: 100%;
  padding: 0.4rem;
  font-size: clamp(0.65rem, 2vw, 0.8rem);
  border-radius: 4px;
  height: 2rem;
}

.select-field {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 0.5rem center;
  background-size: clamp(8px, 2vw, 12px);
}

.input-error {
  border-color: red !important;
}

.error-text {
  color: red;
  font-size: clamp(0.6rem, 1.8vw, 0.7rem);
  display: block;
  margin-top: 0.25rem;
}

.radio-group {
  display: flex;
  gap: 1rem;
}

.radio-label {
  display: flex;
  align-items: center;
}

.radio-label input {
  margin-right: 0.5rem;
}

.phone-input-container {
  display: flex;
  align-items: center;
  width: 100%;
  height: 2rem;
}

.country-dropdown {
  position: relative;
  width: 30%;
  min-width: 40px;
  max-width: 60px;
}


.country-selector {
  width: 100%;
  padding: 0.4rem;
  font-size: clamp(0.65rem, 2vw, 0.8rem);
  border-radius: 4px;
  background-repeat: no-repeat;
  background-size: 20px;
  background-position: center;
  cursor: pointer;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.country-selector:not(:has(img)) {
  background-position: center;
  background-size: clamp(8px, 2vw, 12px);
  justify-content: space-between;
}

.country-dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  width: 200px;
  max-height: 200px;
  overflow-y: auto;
  border-radius: 4px;
  z-index: 10;
  box-shadow: 0 2px 5px rgba(0,0,0,0.1);
  background-color: #ffffff;
}

.country-option {
  width: 100%;
  padding: 0.1rem;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  font-size: clamp(0.65rem, 2vw, 0.8rem);
  text-align: left;
}

.country-flag {
  width: 10px;
  height: 15px;
  margin-right: 0.1rem;
}

.hidden-select {
  display: none;
}

.phone-input-wrapper {
  position: relative;
  width: 100%;
  margin-left: 0.2rem;
}

.country-code {
  position: absolute;
  left: 0.4rem;
  top: 50%;
  transform: translateY(-50%);
  color: gray;
  pointer-events: none;
}

.layout-preview {
  flex: 0 0 15%;
  width: 15%;
  min-width: clamp(350px, 55%, 400px);
  padding: 0.75rem;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 1rem;
  position: relative;
  box-sizing: border-box;
}

.logo-preview {
  max-height: 50px;
  max-width: 80px;
  object-fit: contain;
  border-radius: 4px;
}

.sample-text {
  margin-bottom: 1rem;
  font-size: 11px;
}

.color-picker-buttons {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.color-picker-button {
  padding: 0.4rem;
  font-size: 11px;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  transition: transform 0.2s ease, opacity 0.3s ease;
  min-width: 100px;
}

.color-picker {
  position: absolute;
  top: 0;
  left: 100%;
  z-index: 10;
}

.color-picker.text-color-picker {
  top: 40px;
}

.color-picker.banner-color-picker {
  top: 80px;
}

.date-input-container {
  position: relative;
  width: 100%;
  height: 2rem;
}

.date-input-container input {
  cursor: pointer;
  height: 2rem;
}

.custom-date-picker {
  font-size: clamp(0.65rem, 2vw, 0.8rem);
  z-index: 10;
}

.custom-date-picker .react-datepicker {
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 2px 5px rgba(0,0,0,0.1);
}

.custom-date-picker .react-datepicker__triangle {
  display: none;
}

.custom-date-picker .react-datepicker__header {
  background-color: #f9f9f9;
  border-bottom: 1px solid #ccc;
  padding: 0.5rem;
}

.custom-date-picker .react-datepicker__current-month,
.custom-date-picker .react-datepicker__day-name {
  font-size: clamp(0.6rem, 1.8vw, 0.7rem);
}

.custom-date-picker .react-datepicker__day {
  font-size: clamp(0.6rem, 1.8vw, 0.7rem);
  padding: 0.3rem;
}

.custom-date-picker .react-datepicker__day:hover {
  background-color: #e0e0e0;
  border-radius: 4px;
}

.custom-date-picker .react-datepicker__day--selected,
.custom-date-picker .react-datepicker__day--keyboard-selected {
  background-color: #007bff;
  color: #fff;
  border-radius: 4px;
}

.currency-input {
  display: flex;
  align-items: center;
  height: 2rem; /* Ensure consistent height */
}

.currency-symbol {
  padding: 0.4rem;
  font-size: clamp(0.65rem, 2vw, 0.8rem);
  background-color: #f9f9f9;
  border: none; /* Remove border to attach to input */
  border-radius: 4px 0 0 4px;
  display: flex;
  align-items: center;
  height: 100%; /* Match input height */
}

.currency-input input {
  border-radius: 0 4px 4px 0; /* Round only the right corners */
  height: 100%; /* Match container height */
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  width: 100%;
}

.action-button {
  padding: 0.4rem 1rem;
  font-size: clamp(0.65rem, 2vw, 0.8rem);
  border-radius: 4px;
  border: none;
  cursor: pointer;
  transition: transform 0.2s ease, opacity 0.3s ease;
}

.action-button:hover {
  transform: scale(1.02);
}

.no-outline:focus {
  outline: none !important;
  box-shadow: none !important;
}

@media (max-width: 768px) {
  .input-container {
    flex: 0 0 100%;
    width: 100%;
    min-width: 100%;
  }

  .form-group {
    flex-direction: column;
    gap: 0.5rem;
  }

  .color-picker {
    left: 0;
    top: 100%;
  }

  .color-picker.text-color-picker,
  .color-picker.banner-color-picker {
    top: 100%;
  }

  .nav-tab {
    min-width: 80px;
  }

  .custom-date-picker {
    width: 100%;
  }

  .custom-date-picker .react-datepicker {
    width: 100%;
  }

.phone-input-container {
  display: flex;
  align-items: center;
  width: 100%;
  height: 2rem;
  gap: 0.5rem; /* Add consistent spacing */
}

.country-dropdown {
  position: relative;
  width: clamp(60px, 25%, 100px); /* Flexible width for better scaling */
  min-width: unset; /* Remove restrictive min-width */
  max-width: unset; /* Remove restrictive max-width */
}

  .phone-input-wrapper {
    width: calc(70% - 0.5rem);
    margin-left: 0.5rem;
    margin-top: 0;
  }
}

@media (max-width: 480px) {
  .add-reseller-container {
    padding: 0.5rem;
  }

  .card-container {
    padding: 1rem;
  }

  .nav-tab {
    font-size: clamp(0.6rem, 1.8vw, 0.7rem);
  }

  .tab-controls {
    flex-direction: column;
  }

  .tab-link {
    width: 100%;
    justify-content: flex-start;
  }

  .action-button {
    width: 100%;
    text-align: center;
  }

  .phone-input-container {
    flex-direction: column;
    align-items: flex-start;
  }

  .country-dropdown {
    width: 10%;
    max-width: none;
  }

  .phone-input-wrapper {
    width: 100%;
    margin-left: 0;
    margin-top: 0.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/WebManager/scenes/Reseller/Add&Edit/AddReseller.css"],"names":[],"mappings":";AACA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,8BAA8B;EAC9B,mCAAmC;EACnC,UAAU;EACV,WAAW;EACX,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,SAAW;EACX,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,sCAAsC;EACtC,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,kDAAkD;EAClD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;EACjB,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,8BAA8B;EAC9B,kBAAkB;EAClB,oBAAoB;EACpB,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB,EAAE,2BAA2B;EAChD,gBAAgB,EAAE,qDAAqD;AACzE;;AAEA;EACE,WAAW;EACX,eAAe;EACf,UAAU,EAAE,sCAAsC;EAClD,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,eAAe;EACf,sBAAsB;AACxB;;AAEA,yDAAyD;AACzD;EACE,wDAAwD;AAC1D;;;AAGA;EACE,uCAAuC;EACvC,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,mCAAmC;EACnC,sBAAsB;EACtB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;;;;;;EAME,WAAW;EACX,eAAe;EACf,sCAAsC;EACtC,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,sCAAsC;EACtC,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,yDAAiM;EACjM,4BAA4B;EAC5B,wCAAwC;EACxC,sCAAsC;AACxC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,uCAAuC;EACvC,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,eAAe;AACjB;;;AAGA;EACE,WAAW;EACX,eAAe;EACf,sCAAsC;EACtC,kBAAkB;EAClB,4BAA4B;EAC5B,qBAAqB;EACrB,2BAA2B;EAC3B,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;EACtC,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,kDAAkD;EAClD,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;;EAEE,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;EACvC,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;EAEE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY,EAAE,6BAA6B;AAC7C;;AAEA;EACE,eAAe;EACf,sCAAsC;EACtC,yBAAyB;EACzB,YAAY,EAAE,qCAAqC;EACnD,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,YAAY,EAAE,uBAAuB;AACvC;;AAEA;EACE,0BAA0B,EAAE,iCAAiC;EAC7D,YAAY,EAAE,2BAA2B;AAC3C;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,sCAAsC;EACtC,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE;IACE,cAAc;IACd,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,OAAO;IACP,SAAS;EACX;;EAEA;;IAEE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;AAEF;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,WAAW,EAAE,2BAA2B;AAC1C;;AAEA;EACE,kBAAkB;EAClB,8BAA8B,EAAE,sCAAsC;EACtE,gBAAgB,EAAE,iCAAiC;EACnD,gBAAgB,EAAE,iCAAiC;AACrD;;EAEE;IACE,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,uCAAuC;EACzC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,2BAA2B;EAC7B;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,cAAc;IACd,kBAAkB;EACpB;AACF","sourcesContent":["\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.add-reseller-container {\n  font-family: Arial, sans-serif;\n  font-size: clamp(10px, 2.5vw, 12px);\n  padding: 0;\n  width: 100%;\n  max-width: 100%;\n  margin: 0 auto;\n  box-sizing: border-box;\n}\n\n.loading-overlay {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.spinner {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n.nav-tabs {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  margin-bottom: 1rem;\n  width: 100%;\n  border-radius: 5px;\n  border-bottom: none;\n}\n\n.nav-tab {\n  flex: 1 1 0;\n  min-width: 100px;\n  max-width: 100%;\n  padding: 0.4rem;\n  font-size: clamp(0.65rem, 2vw, 0.8rem);\n  font-weight: bold;\n  text-align: center;\n  border-radius: 5px;\n  border: none;\n  cursor: pointer;\n  transition: transform 0.2s ease, opacity 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  text-decoration: none;\n}\n\n.nav-tab i {\n  font-size: clamp(0.8rem, 2.5vw, 1rem);\n}\n\n.breadcrumb {\n  margin-bottom: 1rem;\n  font-size: clamp(0.65rem, 2vw, 0.8rem);\n  width: 100%;\n  max-width: 100%;\n}\n\n.breadcrumb-divider {\n  margin: 0 0.5rem;\n}\n\n.page-title {\n  font-size: clamp(12px, 3vw, 14px);\n  font-weight: bold;\n  margin-bottom: 1rem;\n}\n\n.tab-controls {\n  display: flex;\n  gap: 1rem;\n  margin-bottom: 1rem;\n  flex-wrap: wrap;\n  width: 100%;\n  max-width: 100%;\n}\n\n.tab-link {\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n  font-weight: bold;\n  font-size: clamp(0.65rem, 2vw, 0.8rem);\n  transition: color 0.3s ease;\n}\n\n.tab-indicator {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: clamp(16px, 3vw, 20px);\n  height: clamp(16px, 3vw, 20px);\n  border-radius: 50%;\n  margin-right: 0.5rem;\n  font-size: clamp(0.6rem, 1.8vw, 0.7rem);\n  transition: all 0.3s ease;\n}\n\n.tab-label {\n  border-bottom: none; /* Removed gray underline */\n  transition: none; /* Removed transition to avoid any visual artifacts */\n}\n\n.tab-content {\n  width: 100%;\n  max-width: 100%;\n  padding: 0; /* let card-container handle spacing */\n  margin-top: 1rem;\n  box-sizing: border-box;\n}\n\n.card-container {\n  border-radius: 12px;\n  padding: 1.5rem;\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n}\n\n/* Optional helper if you want a slightly elevated look */\n.theme-panel {\n  transition: background-color 0.3s ease, border 0.3s ease;\n}\n\n\n.section-title {\n  font-size: clamp(0.7rem, 2.2vw, 0.9rem);\n  font-weight: bold;\n  margin-bottom: 1.5rem;\n}\n\n.section-title--spaced {\n  margin-top: 1.5rem;\n}\n\n.section-subtitle {\n  font-size: clamp(0.65rem, 2vw, 0.8rem);\n  font-weight: normal;\n  margin-bottom: 0.5rem;\n}\n\n.form-group {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  margin-bottom: 1rem;\n  justify-content: flex-start;\n  align-items: flex-start;\n}\n\n.form-group--spaced {\n  margin-bottom: 1rem;\n}\n\n.input-container {\n  flex: 0 0 15%;\n  width: 15%;\n  min-width: clamp(100px, 15%, 150px);\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n}\n\n.input-container.full-width {\n  flex: 0 0 100%;\n  width: 100%;\n  min-width: 100%;\n}\n\n.input-label {\n  display: block;\n  margin-bottom: 0.5rem;\n}\n\n.input-field,\n.select-field,\n.textarea-field,\n.date-input-container,\n.country-selector,\n.file-input-container {\n  width: 100%;\n  padding: 0.4rem;\n  font-size: clamp(0.65rem, 2vw, 0.8rem);\n  border-radius: 4px;\n  outline: none;\n  box-shadow: none;\n  box-sizing: border-box;\n  height: 2rem;\n}\n\n.date-input-container input,\n.file-input-container {\n  width: 100%;\n  padding: 0.4rem;\n  font-size: clamp(0.65rem, 2vw, 0.8rem);\n  border-radius: 4px;\n  height: 2rem;\n}\n\n.select-field {\n  appearance: none;\n  background-image: url(\"data:image/svg+xml;utf8,<svg xmlns=\\\"http://www.w3.org/2000/svg\\\" width=\\\"12\\\" height=\\\"12\\\" viewBox=\\\"0 0 24 24\\\"><path fill=\\\"%23333333\\\" d=\\\"M7 10l5 5 5-5z\\\"/></svg>\");\n  background-repeat: no-repeat;\n  background-position: right 0.5rem center;\n  background-size: clamp(8px, 2vw, 12px);\n}\n\n.input-error {\n  border-color: red !important;\n}\n\n.error-text {\n  color: red;\n  font-size: clamp(0.6rem, 1.8vw, 0.7rem);\n  display: block;\n  margin-top: 0.25rem;\n}\n\n.radio-group {\n  display: flex;\n  gap: 1rem;\n}\n\n.radio-label {\n  display: flex;\n  align-items: center;\n}\n\n.radio-label input {\n  margin-right: 0.5rem;\n}\n\n.phone-input-container {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: 2rem;\n}\n\n.country-dropdown {\n  position: relative;\n  width: 30%;\n  min-width: 40px;\n  max-width: 60px;\n}\n\n\n.country-selector {\n  width: 100%;\n  padding: 0.4rem;\n  font-size: clamp(0.65rem, 2vw, 0.8rem);\n  border-radius: 4px;\n  background-repeat: no-repeat;\n  background-size: 20px;\n  background-position: center;\n  cursor: pointer;\n  height: 2rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.country-selector:not(:has(img)) {\n  background-position: center;\n  background-size: clamp(8px, 2vw, 12px);\n  justify-content: space-between;\n}\n\n.country-dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 200px;\n  max-height: 200px;\n  overflow-y: auto;\n  border-radius: 4px;\n  z-index: 10;\n  box-shadow: 0 2px 5px rgba(0,0,0,0.1);\n  background-color: #ffffff;\n}\n\n.country-option {\n  width: 100%;\n  padding: 0.1rem;\n  align-items: center;\n  gap: 0.5rem;\n  cursor: pointer;\n  font-size: clamp(0.65rem, 2vw, 0.8rem);\n  text-align: left;\n}\n\n.country-flag {\n  width: 10px;\n  height: 15px;\n  margin-right: 0.1rem;\n}\n\n.hidden-select {\n  display: none;\n}\n\n.phone-input-wrapper {\n  position: relative;\n  width: 100%;\n  margin-left: 0.2rem;\n}\n\n.country-code {\n  position: absolute;\n  left: 0.4rem;\n  top: 50%;\n  transform: translateY(-50%);\n  color: gray;\n  pointer-events: none;\n}\n\n.layout-preview {\n  flex: 0 0 15%;\n  width: 15%;\n  min-width: clamp(350px, 55%, 400px);\n  padding: 0.75rem;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  position: relative;\n  box-sizing: border-box;\n}\n\n.logo-preview {\n  max-height: 50px;\n  max-width: 80px;\n  object-fit: contain;\n  border-radius: 4px;\n}\n\n.sample-text {\n  margin-bottom: 1rem;\n  font-size: 11px;\n}\n\n.color-picker-buttons {\n  display: flex;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n\n.color-picker-button {\n  padding: 0.4rem;\n  font-size: 11px;\n  border-radius: 4px;\n  border: none;\n  cursor: pointer;\n  transition: transform 0.2s ease, opacity 0.3s ease;\n  min-width: 100px;\n}\n\n.color-picker {\n  position: absolute;\n  top: 0;\n  left: 100%;\n  z-index: 10;\n}\n\n.color-picker.text-color-picker {\n  top: 40px;\n}\n\n.color-picker.banner-color-picker {\n  top: 80px;\n}\n\n.date-input-container {\n  position: relative;\n  width: 100%;\n  height: 2rem;\n}\n\n.date-input-container input {\n  cursor: pointer;\n  height: 2rem;\n}\n\n.custom-date-picker {\n  font-size: clamp(0.65rem, 2vw, 0.8rem);\n  z-index: 10;\n}\n\n.custom-date-picker .react-datepicker {\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  box-shadow: 0 2px 5px rgba(0,0,0,0.1);\n}\n\n.custom-date-picker .react-datepicker__triangle {\n  display: none;\n}\n\n.custom-date-picker .react-datepicker__header {\n  background-color: #f9f9f9;\n  border-bottom: 1px solid #ccc;\n  padding: 0.5rem;\n}\n\n.custom-date-picker .react-datepicker__current-month,\n.custom-date-picker .react-datepicker__day-name {\n  font-size: clamp(0.6rem, 1.8vw, 0.7rem);\n}\n\n.custom-date-picker .react-datepicker__day {\n  font-size: clamp(0.6rem, 1.8vw, 0.7rem);\n  padding: 0.3rem;\n}\n\n.custom-date-picker .react-datepicker__day:hover {\n  background-color: #e0e0e0;\n  border-radius: 4px;\n}\n\n.custom-date-picker .react-datepicker__day--selected,\n.custom-date-picker .react-datepicker__day--keyboard-selected {\n  background-color: #007bff;\n  color: #fff;\n  border-radius: 4px;\n}\n\n.currency-input {\n  display: flex;\n  align-items: center;\n  height: 2rem; /* Ensure consistent height */\n}\n\n.currency-symbol {\n  padding: 0.4rem;\n  font-size: clamp(0.65rem, 2vw, 0.8rem);\n  background-color: #f9f9f9;\n  border: none; /* Remove border to attach to input */\n  border-radius: 4px 0 0 4px;\n  display: flex;\n  align-items: center;\n  height: 100%; /* Match input height */\n}\n\n.currency-input input {\n  border-radius: 0 4px 4px 0; /* Round only the right corners */\n  height: 100%; /* Match container height */\n}\n\n.form-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.5rem;\n  width: 100%;\n}\n\n.action-button {\n  padding: 0.4rem 1rem;\n  font-size: clamp(0.65rem, 2vw, 0.8rem);\n  border-radius: 4px;\n  border: none;\n  cursor: pointer;\n  transition: transform 0.2s ease, opacity 0.3s ease;\n}\n\n.action-button:hover {\n  transform: scale(1.02);\n}\n\n.no-outline:focus {\n  outline: none !important;\n  box-shadow: none !important;\n}\n\n@media (max-width: 768px) {\n  .input-container {\n    flex: 0 0 100%;\n    width: 100%;\n    min-width: 100%;\n  }\n\n  .form-group {\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n\n  .color-picker {\n    left: 0;\n    top: 100%;\n  }\n\n  .color-picker.text-color-picker,\n  .color-picker.banner-color-picker {\n    top: 100%;\n  }\n\n  .nav-tab {\n    min-width: 80px;\n  }\n\n  .custom-date-picker {\n    width: 100%;\n  }\n\n  .custom-date-picker .react-datepicker {\n    width: 100%;\n  }\n\n.phone-input-container {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: 2rem;\n  gap: 0.5rem; /* Add consistent spacing */\n}\n\n.country-dropdown {\n  position: relative;\n  width: clamp(60px, 25%, 100px); /* Flexible width for better scaling */\n  min-width: unset; /* Remove restrictive min-width */\n  max-width: unset; /* Remove restrictive max-width */\n}\n\n  .phone-input-wrapper {\n    width: calc(70% - 0.5rem);\n    margin-left: 0.5rem;\n    margin-top: 0;\n  }\n}\n\n@media (max-width: 480px) {\n  .add-reseller-container {\n    padding: 0.5rem;\n  }\n\n  .card-container {\n    padding: 1rem;\n  }\n\n  .nav-tab {\n    font-size: clamp(0.6rem, 1.8vw, 0.7rem);\n  }\n\n  .tab-controls {\n    flex-direction: column;\n  }\n\n  .tab-link {\n    width: 100%;\n    justify-content: flex-start;\n  }\n\n  .action-button {\n    width: 100%;\n    text-align: center;\n  }\n\n  .phone-input-container {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .country-dropdown {\n    width: 10%;\n    max-width: none;\n  }\n\n  .phone-input-wrapper {\n    width: 100%;\n    margin-left: 0;\n    margin-top: 0.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
